<template>
    <div class="w-full">
        <div v-if="view === 'edit'" class="w-full border border-gray-200">
            <div class="p-6">
                <div class="w-full mb-4">
                    <div class="flex flex-wrap items-center mt-4 bg-tan-200 border border-b-0">
                        <div class="inline-block px-4 py-2 font-bold text-base"><i class="far fa-clock mr-2"></i>Last Update: {{ lastUpdated || '-' }}</div>
                    </div>
                    <table class="table table-hover border border-t-0 admin-table">
                        <thead>
                            <tr class="bg-gray-super-100">
                                <th class="text-center w-12">Status</th>
                                <th>Commodity</th>
                                <th class="text-center">Month/Year</th>
                                <th class="text-center">Quantity</th>
                                <th class="text-center">Position</th>
                                <th class="text-center">Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(n, index) in 5" :class="{'border-t-0' : index > 0}" :key="index">
                            <tr>
                                <td class="text-center">
                                    <toggle-switch class="ml-2 tgl-dark" :value="form.hidden[index]" :clickable="true" v-model="form.hidden[index]"></toggle-switch>
                                </td>
                                <td>
                                    {{ contracts[form.root[index]][0].symbolName }}
                                </td>
                                <td class="text-center">
                                    <select class="form-control form-control-sm form-control-fixed form-input-modal" v-model="form.contract[index]">
                                        <option v-if="!isContractExists(form.root[index], form.contract[index]) && form.contract[index]">
                                            {{ form.contract[index]['contractMonthYear'] }}
                                        </option>
                                        <option :key="item.symbol" :value="item" v-for="item in contracts[form.root[index]]" :selected="item.contractMonthYear == form.contract[index]">
                                            {{ item.contractMonthYear }}
                                        </option>
                                    </select>
                                </td>
                                <td class="text-center">
                                    <select :class="{ 'is-invalid' : !form.quantity[index] }" v-model="form.quantity[index]" class="form-control form-control-sm form-input-modal" :id="`quantity-` + index">
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                    </select>
                                </td>
                                <td class="text-center">
                                    <select :class="{ 'is-invalid' : !form.position[index] }" v-model="form.position[index]" class="form-control form-control-sm form-input-modal" :id="`position-` + index">
                                        <option value="BUY">BUY</option>
                                        <option value="SELL">SELL</option>
                                        <option value="FLAT">FLAT</option>
                                    </select>
                                </td>
                                <td class="text-center">
                                    <input :class="{ 'is-invalid' : !form.notes[index] }" v-model="form.notes[index]" class="form-input form-input-sm" type="text" :id="`notes-` + index" />
                                </td>
                            </tr>
                            </template>
                        </tbody>
                    </table>
                </div>

                <div class="alert alert-warning mt-12 mb-4 text-sm">
                    <h3>Summary</h3>
                    <p>&bull; To enter a link for a chart type #.</p>
                    <p>&bull; To enter a link to text select the text you want to add the link to.</p>
                    <p>&bull; Drag and drop images where you would like them placed.</p>
                </div>
                <div class="w-full mb-4">
                    <w-editor class="pt-2 border-t" :content="form.summary" v-model="form.summary"></w-editor>
                </div>

                <div class="w-full mt-8">
                    <button @click="handleSave" class="btn btn-yellow">Save</button>
                    <a href="/admin" class="text-black ml-2 btn btn-default">Cancel</a>
                </div>
            </div>
        </div>
        <div v-if="view === 'preview'">
            <button @click="view = 'edit'" class="btn btn-yellow">Edit</button>

            <div v-html="html"></div>

            <button @click="view = 'edit'" class="btn btn-yellow">Edit</button>
        </div>

        <flash-message ref="flash"></flash-message>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import ToggleSwitch from '../Elements/ToggleSwitch';

const props = defineProps({
    initialValues: {
        type: [Object, Array],
        default: () => ({}),
        required: false
    },
    allContracts: {
        type: [Object, Array],
        default: () => ({}),
        required: false
    }
});

const flash = ref(null);
const contracts = ref(props.allContracts || []);
const lastUpdated = ref(props.initialValues.last_updated || '');
const form = ref({
    hidden: props.initialValues.hidden || [false, false, false, false, false],
    root: props.initialValues.root || ['ZC', 'GR', 'CY', 'ZN', 'ET'],
    contract: props.initialValues.contract || [],
    quantity: props.initialValues.quantity || [],
    position: props.initialValues.position || [],
    notes: props.initialValues.notes || [],
    summary: props.initialValues.summary || '',
});
const view = ref('edit');
const errors = ref({});

function isContractExists(root, contract) {
    if (contract) {
        var valObj = contracts.value[root].filter(elem => elem.contractMonthYear == contract.contractMonthYear);
        return (valObj.length > 0);
    }
    return 0;
}

function handleSave() {
    const route = window.route('admin.cttp.update');
    axios.post(route, form.value)
        .then(response => {
            if (response && response.status == 200) {
                flash.value.display('Successfully saved CommodityTrends Trading Plan!');
                lastUpdated.value = response.data.success.created_at;
            } else {
                flash.value.error('Error updating CTTP...');
            }
        }).catch(error => {
            flash.value.error('Error updating CTTP!');
        });
}
</script>
